import { useNavigate } from "react-router-dom";
import {
  Typography,
  Box,
  createTheme,
  ThemeProvider,
  FormControl,
  Select,
  MenuItem,
  Button,
} from "@mui/material";
import Button1 from "../../../toolkit/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import IconButton from "@mui/material/IconButton";
import baseTheme from "../../../themes/baseTheme";
import edit from "../../../icons/edit.svg";
import eyeOn from "../../../icons/Eye In.svg";
import eyeOff from "../../../icons/Eye Off.svg";
import trash1 from "../../../icons/trash1.svg";
import React, { useEffect } from "react";
import axios from "../../../utils/fvAxios";
import BaseURL from "../../../utils/base-uri.json";
import { Link } from "react-router-dom";
import { useState, useContext } from "react";
import PromptDialog from "../../../components/PromptDialog";
import { ChecklistContext } from "../../../store/checklist-context";
const { palette } = baseTheme;
const theme = createTheme({});
const padding = "16px 24px";

export default function ChecklistQuestionDetailsItem({
  status,
  headers = [],
  statusRoleMap,
  onCheckListQuestionSave,
  hasUserInput,
  templateId,
  index,
  ...props
}) {
  status = statusRoleMap[status];
  const navigate = useNavigate();
  const [checklistQuestionId, setChecklistQuestionId] = useState(
    props.checklistQuestionId ?? 0
  );

  const [colValue, setColValue] = useState(props.numberOfColumns);
  const [savedColValue, setSavedColValue] = useState(props.numberOfColumns);
  const [isEditing, setIsEditing] = useState(checklistQuestionId == 0);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isVisible, setIsVisible] = useState(props.isVisible);
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const showEditIcon = checklistQuestionId > 0 ? hasUserInput === false : false;
  const { setRecentlySavedQuestion, refreshCollection, setRefreshCollection } =
    useContext(ChecklistContext);
  const handleChange = (event) => {
    setColValue(event.target.value);
  };

  const addUpdateQuestionInputs = () => {
    setIsSaving(true);
    const _question = {
      ChecklistQuestionId: checklistQuestionId,
      ChecklistQuestionText: props.checklistQuestionText,
      ChecklistSubSectionId: props.checklistSubSectionId,
      Notes: "",
      DisplayOrder: props.displayOrder,
      NumberOfColumns: colValue,
      IsMandatory: props.isMandatory,
      IsVisible: props.isVisible,
      IsBold: props.isBold,
      IsNoteBold: props.isNoteBold,
      QuestionBankId: props.questionBankId,
      HasHighlights: props.hasHighlights,
      checklistQuestionColumnDetails: [],
    };

    //onCheckListQuestionSave(555);
    axios
      .post(BaseURL.templateTool.AddOrUpdateChecklistQuestion, _question)
      .then((response) => {
        if (response.data.responseCode == 100) {
          setChecklistQuestionId(response.data.data);
          setRecentlySavedQuestion({
            id: response.data.data,
            index: index,
            text: props.checklistQuestionText,
          });
          setIsSaving(false);

          setIsEditing(false);
          setSavedColValue(colValue);
        } else console.error(response);
      });
  };

  const changeEditMode = () => {
    setIsEditing(true);
  };

  const handleDoneButton = () => {
    if (checklistQuestionId > 0 && savedColValue !== colValue) {
      setShowPrompt(true);
    } else {
      addUpdateQuestionInputs();
    }
  };

  const handlePromptClose = (confirmed) => {
    setShowPrompt(false);
    if (confirmed) {
      addUpdateQuestionInputs();
    }
  };
  const handleVisibilityMode = () => {
    axios
      .post(BaseURL.templateTool.UpdateQuestionVisibility, {
        QuestionId: checklistQuestionId,
        IsVisible: !props.isVisible,
      })
      .then((response) => {
        setIsVisible(!isVisible);
        props.setTrg(!props.Trg);
      });
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    const resp = await axios.post(
      BaseURL.templateTool.DeleteChecklistQuestions,
      [checklistQuestionId]
    );

    setRefreshCollection(!refreshCollection);

    if (resp.data?.responseMessage === "Success") {
      setDeleteDialogOpen(false);
      setIsDeleting(false);
      // setRefreshCollection((prev) => !prev);
    } else {
      console.error(resp?.data?.responseMessage);
    }
  };
  const handleDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  return (
    <>
      <Dialog open={deleteDialogOpen} onClose={handleDialogClose}>
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        <DialogActions className="w-100 d-flex">
          <Button1
            label="Cancel"
            role="secondary"
            onClick={handleDialogClose}
            style={{ padding: "12px" }}
          />

          {isDeleting ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button1
              label="Yes, delete"
              onClick={confirmDelete}
              style={{ marginLeft: "auto", padding: "12px" }}
            />
          )}
        </DialogActions>
      </Dialog>
      {showPrompt && (
        <PromptDialog
          open={showPrompt}
          onClose={() => {
            setShowPrompt(false);
          }}
          onConfirm={handlePromptClose}
        >
          <p>
            Changing input column(s)? You will have to re-enter question
            attributes. Do you want to proceed?
          </p>
        </PromptDialog>
      )}
      <ThemeProvider theme={theme}>
        <Box
          display="flex"
          padding={padding}
          borderBottom="solid 1px"
          borderColor={palette.grey[30]}
          alignItems="center"
        >
          <Box width={headers.find((h) => h.id === "questiondetails")}>
            <Typography>{props.checklistQuestionText}</Typography>
          </Box>
          <Box width={headers.find((h) => h.id === "questionType")}>
            {checklistQuestionId > 0 && (
              <Link
                to={
                  "/CheckListQuestionDetail?q=" +
                  checklistQuestionId +
                  "&t=" +
                  templateId
                }
                style={{
                  textTransform: "capitalize",
                  textDecoration: "none",
                  color: "rgb(97, 169, 251)",
                }}
              >
                Question Type
              </Link>
            )}
          </Box>
          <Box
            width={headers.find((h) => h.id === "columns")}
            className="text-align-center text-center d-flex"
          >
            {isEditing ? (
              <>
                <Box className="text-muted d-flex align-items-center text-align-center text-center">
                  <Typography className="text-muted">input columns:</Typography>
                  <FormControl sx={{ m: 1 }} variant="standard">
                    <Select
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={colValue}
                      onChange={handleChange}
                    >
                      <MenuItem value={0}>0</MenuItem>
                      <MenuItem value={1}>1</MenuItem>
                      <MenuItem value={2}>2</MenuItem>
                      <MenuItem value={3}>3</MenuItem>
                      <MenuItem value={4}>4</MenuItem>
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={6}>6</MenuItem>
                      <MenuItem value={7}>7</MenuItem>
                      <MenuItem value={8}>8</MenuItem>
                      <MenuItem value={9}>9</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                    </Select>
                  </FormControl>
                </Box>

                {isSaving ? (
                  <Box
                    style={{
                      display: "flex",
                      marginLeft: "auto",
                      padding: "5px",
                    }}
                  >
                    <CircularProgress size={28} />
                  </Box>
                ) : (
                  <Button
                    variant="contained"
                    className="login-button-request mx-2 mt-0"
                    onClick={handleDoneButton}
                  >
                    Done
                  </Button>
                )}
              </>
            ) : (
              <Typography className="text-muted">
                input columns: {colValue}
              </Typography>
            )}
          </Box>

          <Box width={headers.find((h) => h.id === "icons")} className="d-flex">
            {!isEditing && (
              <Typography className="text-break">
                {showEditIcon && (
                  <>
                    <IconButton aria-label="edit" onClick={changeEditMode}>
                      <img src={edit} alt="edit icon" />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      onClick={() => {
                        setDeleteDialogOpen(true);
                        setIsDeleting(false);
                      }}
                    >
                      <img src={trash1} alt="delete icon" />
                    </IconButton>
                  </>
                )}
                {!showEditIcon && (
                  <IconButton
                    aria-label="visibility"
                    onClick={handleVisibilityMode}
                  >
                    <img
                      src={isVisible ? eyeOn : eyeOff}
                      alt="visibility icon"
                    />
                  </IconButton>
                )}
              </Typography>
            )}
          </Box>
        </Box>
      </ThemeProvider>
    </>
  );
}
